(function() {
  'use strict';

  var ARTICLE_SELECTOR = '.dev-guide__content';
  var TOC_LIST_SELECTOR = '#guide-toc-list';
  var MOBILE_LIST_SELECTOR = '#guide-jump-list';
  var MOBILE_TOGGLE_SELECTOR = '#guide-jump-toggle';
  var ACTIVE_CLASS = 'dev-guide-toc__link--active';
  var MOBILE_ACTIVE_CLASS = 'active';

  function init() {
    var article = document.querySelector(ARTICLE_SELECTOR);
    if (!article) return;

    var headings = article.querySelectorAll('h2');
    if (headings.length === 0) return;

    headings.forEach(function(h, i) {
      if (!h.id) {
        h.id = 'section-' + i;
      }
    });

    var tocList = document.querySelector(TOC_LIST_SELECTOR);
    if (tocList) {
      buildTocLinks(tocList, headings, 'dev-guide-toc__link');
    }

    var mobileList = document.querySelector(MOBILE_LIST_SELECTOR);
    if (mobileList) {
      buildTocLinks(mobileList, headings, '');
    }

    var mobileToggle = document.querySelector(MOBILE_TOGGLE_SELECTOR);
    if (mobileToggle && mobileList) {
      mobileToggle.addEventListener('click', function() {
        mobileList.classList.toggle('open');
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
          }
        });
      }, {
        rootMargin: '-20% 0px -70% 0px'
      });

      headings.forEach(function(h) {
        observer.observe(h);
      });
    }
  }

  function buildTocLinks(container, headings, linkClass) {
    headings.forEach(function(h) {
      var li = document.createElement('li');
      if (linkClass) li.className = 'dev-guide-toc__item';
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      if (linkClass) a.className = linkClass;
      a.addEventListener('click', function(e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var mobileList = document.querySelector(MOBILE_LIST_SELECTOR);
        if (mobileList) mobileList.classList.remove('open');
      });
      li.appendChild(a);
      container.appendChild(li);
    });
  }

  function setActive(id) {
    var tocLinks = document.querySelectorAll(TOC_LIST_SELECTOR + ' a');
    tocLinks.forEach(function(a) {
      if (a.getAttribute('href') === '#' + id) {
        a.classList.add(ACTIVE_CLASS);
      } else {
        a.classList.remove(ACTIVE_CLASS);
      }
    });

    var mobileLinks = document.querySelectorAll(MOBILE_LIST_SELECTOR + ' a');
    mobileLinks.forEach(function(a) {
      if (a.getAttribute('href') === '#' + id) {
        a.classList.add(MOBILE_ACTIVE_CLASS);
      } else {
        a.classList.remove(MOBILE_ACTIVE_CLASS);
      }
    });

    var toggle = document.querySelector(MOBILE_TOGGLE_SELECTOR);
    if (toggle) {
      var activeHeading = document.getElementById(id);
      if (activeHeading) {
        toggle.textContent = '📑 ' + activeHeading.textContent + ' ▾';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
